import { itemTypeMetadataToName, ToItemTypeMetadata } from "../item-type-metadata.enum";
import { Metadata } from "../metadata.model";
import { WidgetJsonSchema, WidgetJsonSchemaBase } from "../schema/widget-json-schema.model";


export class ItemMetadataBase implements Metadata {

    id: string = '' + Math.floor(Math.random() * 1000000)
    type: string = "none"
    fieldName: string = "fieldName" + Math.floor(Math.random() * 1000000)
    fieldLabel: string = "Etiqueta"
    required: boolean = false
    readonly: boolean = false
    hiddenExpression: string | null = null
    expressionProperties: string | null = null
    validatorName: string | null = null
    hint: string | null = null
    defaultValue: any = null

    constructor(type: string) {
        this.type = type
        let t = ToItemTypeMetadata(type)
        if (t) {
            this.fieldLabel = itemTypeMetadataToName(t) +  ` (ID:${this.id})`
        }
    }

    schema(): WidgetJsonSchema {
        return new WidgetJsonSchemaBase(ToItemTypeMetadata(this.type))
    }

    from(data: ItemMetadata): void {
        Object.assign(this, data)
    }

}

export interface ItemMetadata extends ItemMetadataBase { }